/**
 * Devuelve la fecha local en formato YYYY-MM-DD.
 */
export function fechaLocalYMD(date: string | Date = new Date()): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('sv-SE');
}

/**
 * Formatea una cadena ISO/datetime como hora legible en Costa Rica (HH:MM).
 * Usar en lugar de new Date(str).toLocaleTimeString('es-CR', ...).
 */
export function formatTimeCR(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleTimeString('es-CR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Formatea una cadena ISO/datetime como fecha legible en Costa Rica.
 * Usar en lugar de new Date(str).toLocaleDateString('es-CR').
 */
export function formatDateCR(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('es-CR');
}
